import React from 'react';
import { StarIcon } from 'lucide-react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { buyers } from '../data/offer';
export function Buyers() {
  return <section className="bg-ivory-2 py-14" data-id="element-35" data-mp="3nofljglzqj04">
      <div className="px-5" data-id="element-36" data-mp="3ipl1kbcaeoef">
        <SectionHeading eyebrow="Chi l’ha già scelto" title="Insegnanti che usano" accent="già il pack" sub="Alcune delle persone che hanno acquistato Flauto Master." data-id="element-37" data-mp="3iqdykklg1zjd" />
      </div>
      <Reveal className="mt-9" data-id="element-38" data-mp="f69lwla60r4f">
        <ul className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Insegnanti che hanno acquistato il pack" data-id="element-39" data-mp="a8zpgloczf73">
          {buyers.map(b => <li key={b.name} className="flex w-[78%] shrink-0 snap-center flex-col overflow-hidden rounded-2xl border border-ivory-line bg-ivory-white shadow-soft" data-id="element-40" data-mp="2v0s2i60dc0fl">
              <div className="relative" data-id="element-41" data-mp="2zz0d1ke4v4p6">
                <img src={b.photo} alt={`${b.name}, ${b.role}`} className="aspect-[4/5] w-full object-cover" data-id="element-42" data-mp="34xv419m97zkd" />
                <div className="absolute inset-x-0 bottom-0 bg-espresso/85 px-4 py-3 backdrop-blur-sm" data-id="element-43" data-mp="2q0u80tx15ig3">
                  <p className="font-display text-xl uppercase leading-tight text-ivory" data-id="element-44" data-mp="2uy47l2e4vahn">{b.name}</p>
                  <p className="text-xs text-sand" data-id="element-45" data-mp="2h6pnes8hp390">
                    {b.role} · {b.city}
                  </p>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-4" data-id="element-46" data-mp="2m0afy4rbd50t">
                <div className="flex gap-0.5" aria-label="5 stelle su 5" data-id="element-47" data-mp="27aw0cex59rcz">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-wood text-wood" aria-hidden="true" data-id="element-48" data-mp="2c6bd13jf1h7t" data-mpi={i} />)}
                </div>
                <blockquote className="mt-2 font-serif text-[16px] italic leading-relaxed text-ink" data-id="element-49" data-mp="229f2ytdvcn15">
                  “{b.quote}”
                </blockquote>
              </div>
            </li>)}
        </ul>
        <p className="mt-2 text-center text-xs text-ink-muted" data-id="element-50" data-mp="3zg9n31oqil4">Scorri per vedere le altre →</p>
      </Reveal>
      <div className="px-5" data-id="element-51" data-mp="3v7lqjz340l9o">
        <InlineCta label="Unisciti a loro" data-id="element-52" data-mp="3q8959irvzm97" />
      </div>
    </section>;
}